module.exports = __webpack_public_path__ + "img/tree-08-c-trunk.f64efe51.png";